import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'YkCopy',
  components: {},
  props: {
    text: {
      type: String || Number,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted: function mounted() {},
  methods: {
    handleCopy: function handleCopy() {
      this.$message.success('复制成功');
      this.$emit('copySuccess');
    }
  }
};